import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DTextFormControl } from "../../entities/form-control";
import { FormField } from "../../entities/form-field";

@Component({
	selector: "form-text",
	template: `
		<div class="dynamic-field form-text" [formGroup]="group">
			<label>
				<ng-content select="h3" />

				<input
					type="text"
					[formControlName]="config.name"
					[maxLength]="config.maxLength"
					[minlength]="config.minLength"
					[pattern]="config.pattern"
					[placeholder]="placeholder | i18n"
				/>

				@if (config.suffix && config.suffix.type === "icon") {
					<span class="suffix suffix-icon" [ngClass]="config.suffix.value"> </span>
				}

				@if (config.suffix && config.suffix.type === "text") {
					<span class="suffix suffix-text">
						{{ config.suffix.value }}
					</span>
				}
			</label>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FormTextComponent implements FormField {
	@Input() config: DTextFormControl;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
